export type Tomo = {
  numero: string
  titulo: string
  descripcion: string
}

export const tomos: Tomo[] = [
  {
    numero: '01',
    titulo: 'El fin de la resistencia',
    descripcion:
      'La ciencia 2026 detrás de los "superpiojos": por qué mutaron y qué los sigue matando.',
  },
  {
    numero: '02',
    titulo: 'Recetario de Asfixia Biológica',
    descripcion:
      'Fórmulas hechas en casa por menos de $5, con lo que ya tienes en la cocina.',
  },
  {
    numero: '03',
    titulo: 'Técnica de Extracción Profesional',
    descripcion:
      'El secreto del ángulo: cómo peinar para sacar liendres pegadas en la primera pasada.',
  },
  {
    numero: '04',
    titulo: 'Protocolo Discreto para Adultos',
    descripcion:
      'Trátate sin que nadie lo note, sin faltar al trabajo y sin olores delatores.',
  },
  {
    numero: '05',
    titulo: 'Plan de Desinfección Express',
    descripcion:
      'Tu casa libre en 45 minutos. Se acabaron las lavadas de sábanas a medianoche.',
  },
  {
    numero: '06',
    titulo: 'El Escudo Invisible',
    descripcion:
      'Blindaje escolar diario para que el brote de la clase no vuelva a entrar a tu casa.',
  },
]

export type ValueItem = {
  nombre: string
  valor: string
  bono?: boolean
}

export const valueStack: ValueItem[] = [
  { nombre: 'Megapack 6 Tomos Completos', valor: '$139.900' },
  { nombre: 'Bono 1: Checklist "Brote en el Cole"', valor: '$19.900', bono: true },
  { nombre: 'Bono 2: Guía Maestra de Aceites Esenciales', valor: '$26.900', bono: true },
  { nombre: 'Bono 3: Tarjetas de Notificación Anónima', valor: '$11.900', bono: true },
  { nombre: 'Bono 4: Calendario de Seguimiento 14 Días', valor: '$11.900', bono: true },
  { nombre: 'Bono 5: Masterclass Técnica del Peine', valor: '$33.900', bono: true },
]

export type Testimonio = {
  cita: string
  nombre: string
  detalle: string
  foto: string
}

export const testimonios: Testimonio[] = [
  {
    cita:
      'Mi hija tenía el cuero cabelludo rojo de tanto químico que probamos. Con este manual, entendí que el secreto era la asfixia natural. ¡En una tarde se acabó la pesadilla!',
    nombre: 'Mariana S.',
    detalle: 'Madre de 2 niños',
    foto:
      'https://cdn.magicpatterns.com/patterns/generated-images/1473c05a-3f23-4430-b4ef-91287f2c30c7.jpg',
  },
  {
    cita:
      'Lo que más me sirvió fue el spray repelente. Mi hijo es el único de su clase que no se ha contagiado en este nuevo brote.',
    nombre: 'Jorge L.',
    detalle: 'Padre soltero',
    foto:
      'https://cdn.magicpatterns.com/patterns/generated-images/a1c95d59-b0c5-424d-bf0d-74c6a9f1af77.jpg',
  },
]

export type Faq = {
  pregunta: string
  respuesta: string
}

export const faqs: Faq[] = [
  {
    pregunta: '¿Es un producto físico?',
    respuesta:
      'No, es un Megapack digital de acceso inmediato para que puedas empezar el tratamiento ahora mismo, sin esperar envíos.',
  },
  {
    pregunta: '¿Necesito ingredientes caros?',
    respuesta:
      'No. Todo se fabrica con elementos que ya tienes en tu cocina o que consigues por centavos en el súper.',
  },
  {
    pregunta: '¿Sirve para cabellos rizados?',
    respuesta:
      'Sí. Incluimos una sección técnica dedicada a cabellos difíciles, rizados y muy largos.',
  },
]
